const StackItemInterface = {
    getId() {
        return this.id;
    },
};

export default StackItemInterface;
